import React from 'react';
import {reduxForm, Field} from 'redux-form';
import {Link} from 'react-router-dom';
import LOGO from '../../img/logo.svg';

let ForgotPasswordForm = (props) => {

    const {handleSubmit,pristine,submitting} = props;

    return (
        <div className="form">
            <form onSubmit={handleSubmit}>
                <div className="form_logo">
                    <Link to={'/'}><img src={LOGO} alt="Reliance HMO's Logo"/></Link>
                </div>
                <Field component="input" type="text" name="hmo_id" placeholder="Your HMO ID" required/>
                <button type="submit" disabled={pristine||submitting}>Reset Password</button>
            </form>
        </div>
    )
};


ForgotPasswordForm = reduxForm({
    form:'forgotPasswordForm'
})(ForgotPasswordForm);

export default ForgotPasswordForm